'use client';

import React from 'react';
import { Box, Typography, IconButton, useMediaQuery, useTheme, Button } from '@mui/material';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import HamburgerNavbarMenu from './hamburger_navbar_menu';
import DiscoBall from './disco_ball';
import LinkWithLoading from './link_with_loading';
import { useUserVenues } from '../hooks/useUserVenues';
import { getNavigationInfo } from '../lib/navigation-helpers';
import { useAuthState } from '../lib/firebase/app';

export function LogoAndHamburgerNavBar() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { user, loading } = useAuthState();
    const { singleVenue, loading: venuesLoading } = useUserVenues();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 2 }}>
            <Box sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 24px',
            }}>
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', position: 'relative', ml: -2 }}>
                    <Box sx={{ position: 'absolute', width: '60px', height: '60px', left: 0, top: '50%', transform: 'translateY(-50%)' }}>
                        <DiscoBall />
                    </Box>
                    <LinkWithLoading href='/' passHref>
                        <Typography
                            fontFamily='Inter'
                            fontSize='1.5rem'
                            color='white'
                            sx={{
                                fontWeight: 'bold',
                                position: 'absolute',
                                fontFamily: 'Fancy',
                                left: '30px',
                                top: '50%',
                                transform: 'translateY(-35%)',
                                zIndex: 2,
                                textShadow: '2px 2px 8px rgba(0, 0, 0, 0.6)'
                            }}
                        >
                            litty
                        </Typography>
                    </LinkWithLoading>
                </Box>

                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Button
                            variant="outlined"
                            href={getNavigationInfo(user, loading, singleVenue, venuesLoading).href}
                            sx={{
                                borderRadius: '2rem',
                                borderColor: 'rgba(255, 255, 255, 0.5)',
                                color: 'white',
                                px: 3,
                                py: 0.8,
                                textTransform: 'none',
                                fontWeight: 500,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    borderColor: 'white',
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                }
                            }}
                        >
                            {getNavigationInfo(user, loading, singleVenue, venuesLoading).text}
                        </Button>
                        <HamburgerNavbarMenu />
                        {!isMobile && (
                            <IconButton
                                color="inherit"
                                sx={{ ml: 1, color: 'gray' }}
                                aria-label="Profile"
                                onClick={() => window.open('/profile', '_blank')}
                            >
                                <AccountCircleOutlined />
                            </IconButton>
                        )}
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                }}
            />
        </Box>
    );
}
